import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

function MyTrips() {
  const mainStyle = {
    padding: '60px 40px',
    minHeight: '400px',
    textAlign: 'center',
  };

  return (
    <>
      <Navbar />
      <div style={mainStyle}>
        <h1>My Trips</h1>
        <p style={{ marginTop: '20px', color: '#666' }}>
          Check and manage your booking history here.
        </p>
      </div>
      <Footer />
    </>
  );
}

export default MyTrips;
